export function formatNumber(num: number) : number {
    const abs = Math.abs(num)
    let fractionDigits: number

    if (abs >= 100000) {
      fractionDigits = 0
    } else if (abs >= 1000) {
      fractionDigits = 1
    } else if (abs >= 1) {
      fractionDigits = 2
    } else if (abs >= 0.01) {
      fractionDigits = 4
    } else if (abs >= 0.001) {
      fractionDigits = 6
    } else {
      fractionDigits = 8
    }
    return +num.toFixed(fractionDigits);
}